import bootbox from 'bootbox';

$(document).ready(function (e) {

    let $report_table = $('.report-table'),
        $body = $('body'),
        $chart_type = $('#chart-type'),
        decimal_separator = $('.dashboards').attr('data-decimal-separator'),
        thousands_separator = $('.dashboards').attr('data-thousands-separator'),
        lang = $('.dashboards').attr('data-lang');

    $('.select-report-table').on('click', function (e) {

        e.preventDefault();

        let table_id = $(this).data('table-id'),
            table_name = $(this).text();

        $($report_table).text(table_name).attr('data-table-id', table_id);

        $.ajax({
            type: 'GET',
            url: '/tablebuilder/table/fields',
            data: {
                id: table_id
            },
            success: function (res) {
                populateFunctionDropdown(res);
                populateSummarizeDropdown(res);
                populateFiltersDropDown(table_id);
                drawChart($("#chart-type").val());

                $('.save-report').removeClass('d-none');
            }
        })
    });

    function populateFiltersDropDown(table) {
        $.ajax({
            type: 'GET',
            url: '/report/filters',
            data: {
                table
            },
            success: function (filters) {
                $('.chart-filters').empty();
                $(filters).each(function (i, filter) {
                    $('.chart-filters').append(`                                            
                        <a class="dropdown-item select-report-filter" href="#" data-filter-id="${filter.id}" data-filter-name="${filter.name}">${filter.name}</a>
                    `);
                })
            }
        })
    }

    function populateFunctionDropdown(fields) {
        let $dropdowns = $('.functions-dropdown');

        $($dropdowns).each(function (i, $dropdown) {

            let $fields = $($dropdown).find('.fields'),
                $functions = $($dropdown).find('.functions');

            $($fields).empty();

            $(fields).each(function (i, field) {
                $($fields).append(`<div class="field function-field" data-field-type="${field.field_type}" data-type="${field.type}" data-field-id="${field.id}">${field.label}</div>`);
            });

            $($functions).find('.function[data-function="Count"]').trigger('click');
            $($fields).find('.function-field:first-child').trigger('click', ['table_selected']);

        });
    }

    function populateSummarizeDropdown(fields) {
        let $dropdowns = $('.summarize-dropdown');

        $($dropdowns).each(function (i, $dropdown) {

            let $fields = $($dropdown).find('.fields');

            $($fields).empty();

            $(fields).each(function (i, field) {
                $($fields).append(`<div class="field summarize-field ${i === 0 && 'active'}" data-field-type="${field.field_type}" data-type="${field.type}" data-name="${field.name}" data-field-id="${field.id}">${field.label}</div>`);
            });

            $($fields).find('.field[data-name="created_by"]').trigger('click');
        });
    }

    $body.on('click', '.add-axis', function (e) {
        e.preventDefault();
        let $clone = $(this).next('.btn-group').clone(),
            type = $(this).attr('data-type'),
            table_id = $('.report-table').data('table-id'),
            $this = $(this);

        $.ajax({
            type: 'GET',
            url: `/chart/dropdown/${type}`,
            data: {
                id: table_id
            },
            success: function (res) {
                $this.parents('.form-group').append(res);
                if (type === 'summarize') {
                    let $newBtn = $this.parents('.form-group').find('.btn-group:last-child');
                    $($newBtn).find('.field[data-name="assigned_to"]').trigger('click');
                    $($newBtn).find('.function[data-function="Count"]').trigger('click');
                }

                drawChart($("#chart-type").val());
            }
        })
    });

    $body.on('click', '.remove-axis', function (e) {
        e.preventDefault();
        $(this).parents('.btn-group').remove();
        drawChart($("#chart-type").val());
    });

    $body.on('click', '.function', function (e) {
        let $function = $(this),
            $field = $(this).parents('.row').find('.field.active'),
            report_table = $($report_table).text(),
            function_name = $function.text().trim(),
            text = `${function_name} of ${report_table}.${$field.text()}`,
            numeric_functions = ['Sum', 'Maximum', 'Minimum', 'Average'],
            numeric_fields = ['decimal', 'number', 'currency', 'formula'],
            $fields = $($function).parents('.function-fields-holder').find('.fields').find('.field');

        $function.siblings('.function').removeClass('active');
        $function.addClass('active');
        $fields.addClass('d-none');

        if (numeric_functions.includes(function_name)) {
            $fields.each(function (i, $field) {
                let type = $($field).attr('data-type'),
                    field_type = $($field).attr('data-field-type');

                if (numeric_fields.includes(field_type)) {
                    $($field).removeClass('d-none');
                }
            });
        } else {
            $fields.removeClass('d-none');
        }

        let $visibleField = $($function).parents('.function-fields-holder').find('.fields').find('.field.active:not(.d-none)');

        $visibleField.trigger('click');

    });

    $body.on('click', '.field', function (e, action) {
        let $field = $(this),
            $function = $(this).parents('.function-fields-holder').find('.function.active'),
            report_table = $($report_table).text().trim(),
            text = `${$function.text()} of ${report_table}.${$field.text()}`,
            chart_type = $('#chart-type').val(),
            field_id = $(this).attr('data-field-id');

        $field.siblings('.field').removeClass('active');
        $field.addClass('active');

        if ($($field).parents('.summarize-holder').length) {

            console.log(action);
            $field.parents('.dropdown-menu').siblings('button').text(text);
            let has_column = $('.column-holder').find('.function-field.active[data-field-id="' + field_id + '"]').length;

            // if (!has_column) {
            //     if (action !== 'table_selected') {
            //         $('.add-axis[data-type="columns"]').trigger('click');
            //         setTimeout(function () {
            //             $('.summarize-dropdown').last().find('.field[data-field-id="' + field_id + '"]').trigger('click');
            //         }, 200);
            //     }
            // }
        } else {
            text = `${report_table}.${$field.text()}`;
            $field.parents('.dropdown-menu').siblings('button').text(text);
        }

        drawChart(chart_type);
    });

    $body.on('click', '.select-report-filter', function (e) {
        e.preventDefault();
        $(this).siblings('.select-report-filter').removeClass('active');

        let filter_name = $(this).attr('data-filter-name'),
            filter_id = $(this).attr('data-filter-id'),
            $report_filter = $('.report-filter'),
            $filter_toggle = $('.filter-toggle');

        if ($(this).hasClass('active')) {
            $(this).removeClass('active');
            $report_filter.text('-- Select Filter --').removeAttr('data-filter-id');
            $filter_toggle.addClass('d-none');
        } else {
            $(this).addClass('active');
            $report_filter.text(filter_name).attr('data-filter-id', filter_id);
            $filter_toggle.removeClass('d-none');
        }

        drawChart($("#chart-type").val());
    });

    $body.on('click', '.filter-toggle', function (e) {
        e.preventDefault();

        let $report_filter = $('.report-filter'),
            $filter_toggle = $('.filter-toggle'),
            $active_item = $('.select-report-filter.active');

        $active_item.removeClass('active');
        $report_filter.text('-- Select Filter --').removeAttr('data-filter-id');
        $filter_toggle.addClass('d-none');

        drawChart($("#chart-type").val());
    });

    $body.on('click', '.dropdown-body', function (e) {
        e.stopPropagation();
    });

    $('.save-report').on('click', function (e) {
        e.preventDefault();

        let chart_type = $('#chart-type').val(),
            table_id = $('.report-table').attr('data-table-id'),
            y_axis_payload = [],
            x_axis_payload = [],
            rows_payload = [],
            action = $(this).attr('data-action'),
            filter_id = $('.report-filter').attr('data-filter-id'),
            $save_report_modal = $('#save-report-modal');

        let $dropdowns = $('.functions-dropdown');

        $($dropdowns).each(function (i, $dropdown) {

            let $fields = $($dropdown).find('.fields'),
                $functions = $($dropdown).find('.functions');

            let function_name = $($functions).find('.function.active').attr('data-function'),
                field = $($fields).find('.function-field.active').attr('data-field-id');

            let payload = {
                fx: function_name,
                field: field
            };

            y_axis_payload.push(payload);
        });

        $dropdowns = $('.summarize-dropdown.columns');

        $($dropdowns).each(function (i, $dropdown) {

            let $fields = $($dropdown).find('.fields');

            let field = $($fields).find('.field.active').attr('data-field-id');

            x_axis_payload.push({field: field});
        });

        $dropdowns = $('.summarize-dropdown.rows');

        $($dropdowns).each(function (i, $dropdown) {

            let $fields = $($dropdown).find('.fields');

            let field = $($fields).find('.field.active').attr('data-field-id');

            rows_payload.push({field: field});
        });

        if (action === 'confirm') {
            $save_report_modal.modal('show');
        } else {

            $('.error').text('');

            let report_label = $('#report-label').val(),
                report_name = $('#report-name').val(),
                report_description = $('#report-description').val(),
                report_dashboard = $('#report-dashboard').val();

            $.ajax({
                type: 'POST',
                url: '/report',
                data: {
                    chart_type,
                    table_id,
                    y_axis_payload,
                    x_axis_payload,
                    rows_payload,
                    report_label,
                    report_name,
                    report_description,
                    report_dashboard,
                    filter_id
                },
                success: function (res) {
                    if (res) {
                        window.location = `/dashboard/${report_dashboard[0]}`;
                    }
                },
                error: function (res) {
                    let errors = res.responseJSON.errors;

                    for (let key in errors) {
                        if (errors.hasOwnProperty(key)) {
                            $(`.error[data-name="` + key + `"]`).text(errors[key]);
                        }
                    }
                }
            });
        }
    });

    $('.update-report').on('click', function (e) {
        e.preventDefault();

        let chart_type = $('#chart-type').val(),
            table_id = $('.report-table').attr('data-table-id'),
            y_axis_payload = [],
            x_axis_payload = [],
            rows_payload = [],
            filter_id = $('.report-filter').attr('data-filter-id'),
            action = $(this).attr('data-action'),
            $save_report_modal = $('#save-report-modal');

        let $dropdowns = $('.functions-dropdown');

        $($dropdowns).each(function (i, $dropdown) {

            let $fields = $($dropdown).find('.fields'),
                $functions = $($dropdown).find('.functions');

            let function_name = $($functions).find('.function.active').attr('data-function'),
                field = $($fields).find('.function-field.active').attr('data-field-id');

            let payload = {
                fx: function_name,
                field: field
            };

            y_axis_payload.push(payload);
        });

        $dropdowns = $('.summarize-dropdown.columns');

        $($dropdowns).each(function (i, $dropdown) {

            let $fields = $($dropdown).find('.fields');

            let field = $($fields).find('.field.active').attr('data-field-id');

            x_axis_payload.push({field: field});
        });

        $dropdowns = $('.summarize-dropdown.rows');

        $($dropdowns).each(function (i, $dropdown) {

            let $fields = $($dropdown).find('.fields');

            let field = $($fields).find('.field.active').attr('data-field-id');

            rows_payload.push({field: field});
        });

        if (action === 'confirm') {
            $save_report_modal.modal('show');
        } else {

            $('.error').text('');

            let report_label = $('#report-label').val(),
                report_name = $('#report-name').val(),
                report_description = $('#report-description').val(),
                report_dashboard = $('#report-dashboard').val(),
                id = $(this).attr('data-chart-id');

            $.ajax({
                type: 'POST',
                url: `/report/${id}/update`,
                data: {
                    chart_type,
                    table_id,
                    y_axis_payload,
                    x_axis_payload,
                    rows_payload,
                    report_label,
                    report_name,
                    report_description,
                    report_dashboard,
                    id,
                    filter_id
                },
                success: function (res) {
                    if (res) {
                        window.location = `/dashboard/${report_dashboard[0]}`;
                    }
                },
                error: function (res) {
                    let errors = res.responseJSON.errors;

                    for (let key in errors) {
                        if (errors.hasOwnProperty(key)) {
                            $(`.error[data-name="` + key + `"]`).text(errors[key]);
                        }
                    }
                }
            });
        }
    });

    $('.create-dashboard').on('click', function (e) {
        e.preventDefault();

        let $name = $('#dashboard-name'),
            $label = $('#dashboard-label');

        if ($name.val().length && $label.val().length) {
            $.ajax({
                type: 'POST',
                url: '/report/dashboard/new',
                data: {
                    name: $name.val(),
                    label: $label.val()
                },
                success: function (id) {
                    if (id) {
                        let $selectpicker = $('#report-dashboard');
                        let existing_values = $selectpicker.val();
                        existing_values.push(id);
                        $selectpicker.append(`<option value="${id}">${$label.val()}</option>`).val(id);
                        $selectpicker.selectpicker('refresh');
                        $selectpicker.selectpicker('val', existing_values);
                        $name.val('');
                        $label.val('');
                        $('.new-dashboard-form').addClass('d-none');
                    }
                }
            })
        } else {
            alert('Please provide name and label for your dashboard');
        }
    });

    $('.delete-dashboard').on('click', function (e) {
        e.preventDefault();
        let dashboard_id = $(this).attr('data-dashboard-id');

        bootbox.confirm("Are you sure want to delete dashboard?", function (result) {
            if (result) {
                $.ajax({
                    type: 'DELETE',
                    url: `/dashboard/${dashboard_id}`,
                    success: function (res) {
                        if (res) {
                            window.location = '/';
                        }
                    }
                })
            }
        })
    });

    $('.icon-edit-dashboard').on('click', function (e) {
        e.preventDefault();
        window.location = $(this).attr('data-url');
    });

    $('#add-dashboard').on('click', function (e) {
        $('.new-dashboard-form').removeClass('d-none');
    });

    $('.cancel-create-dashboard').on('click', function (e) {
        $('.new-dashboard-form').addClass('d-none');
    });

    $chart_type.on('change', function (e) {
        let type = $(this).val(),
            $x_axis = $('.x-axis-text'),
            $y_axis = $('.y-axis-text'),
            $rows_holders = $('.rows-holder'),
            $summarize_holder = $('.summarize-holder'),
            $columns_holder = $('.column-holder');

        let no_axis_chars = ['Pie', 'Donut'],
            tables = ['Table', 'SubTable'];

        $rows_holders.addClass('d-none');
        $summarize_holder.addClass('d-none');
        $columns_holder.addClass('d-none');

        if (no_axis_chars.includes(type)) {
            $y_axis.text('Summarize');
            $x_axis.text('By Color');
            $summarize_holder.removeClass('d-none');
            $columns_holder.removeClass('d-none');
        } else if (type === 'SubTable') {
            $y_axis.text('Summarize');
            $x_axis.text('Columns');
            $rows_holders.removeClass('d-none');
            $summarize_holder.removeClass('d-none');
            $columns_holder.removeClass('d-none');
        } else if (type === 'Table') {
            $y_axis.text('Summarize');
            $x_axis.text('Columns');
            $summarize_holder.removeClass('d-none');
            $columns_holder.removeClass('d-none');
            $rows_holders.addClass('d-none');
        } else {
            $summarize_holder.removeClass('d-none');
            $columns_holder.removeClass('d-none');
            $x_axis.text('X-Axis');
            $y_axis.text('Y-Axis');
        }
        drawChart(type);
    });

    function drawChart(type) {

        let chart_type = $('#chart-type').val(),
            table_id = $('.report-table').attr('data-table-id'),
            y_axis_payload = [],
            x_axis_payload = [],
            rows_payload = [],
            filter_id = $('.report-filter').attr('data-filter-id');

        let $dropdowns = $('.functions-dropdown');

        $($dropdowns).each(function (i, $dropdown) {

            let $fields = $($dropdown).find('.fields'),
                $functions = $($dropdown).find('.functions');

            let function_name = $($functions).find('.function.active').attr('data-function'),
                field = $($fields).find('.function-field.active').attr('data-field-id');

            let payload = {
                fx: function_name,
                field: field
            };

            y_axis_payload.push(payload);
        });

        $dropdowns = $('.summarize-dropdown.columns');

        $($dropdowns).each(function (i, $dropdown) {
            let $fields = $($dropdown).find('.fields');
            let field = $($fields).find('.field.active').attr('data-field-id');
            x_axis_payload.push({field: field});
        });

        $dropdowns = $('.summarize-dropdown.rows');

        $($dropdowns).each(function (i, $dropdown) {
            let $fields = $($dropdown).find('.fields');
            let field = $($fields).find('.field.active').attr('data-field-id');
            rows_payload.push({field: field});
        });

        $.ajax({
            type: 'GET',
            url: '/chart/preview',
            data: {
                chart_type,
                table_id,
                y_axis_payload,
                x_axis_payload,
                rows_payload,
                filter_id
            },
            success: function (res) {
                $('#chart-div').removeClass('d-none');
                $('#table-div').addClass('d-none');

                if (type === 'Bar') {
                    drawBarChart(res);
                } else if (type === 'Line') {
                    drawLineChart(res)
                } else if (type === 'Pie') {
                    drawPieChart(res);
                } else if (type === 'Donut') {
                    drawDonutChart(res);
                } else if (type === 'Area') {
                    drawAreaChart(res);
                } else if (type === 'Scatter') {
                    drawScatterChart(res);
                } else if (type === 'Stacked Bar') {
                    drawStackedBarChart(res);
                } else if (type === 'Table' || type === 'SubTable') {
                    drawTable(res);
                }
            }
        })
    }

    function drawTable(res) {
        $('#chart-div').addClass('d-none');
        $('#table-div').removeClass('d-none').html(res);
    }

    function drawBarChart(res) {
        google.charts.load('current', {packages: ['corechart', 'bar'], 'language': lang});
        google.charts.setOnLoadCallback(function () {
            let data = google.visualization.arrayToDataTable(res.data);
            let options = res.options;
            let chart = new google.visualization.ColumnChart(document.getElementById('chart-div'));
            let formatting = new google.visualization.NumberFormat({
                decimalSymbol: decimal_separator,
                groupingSymbol: thousands_separator
            });
            formatting.format(data, 1);
            chart.draw(data, options);
        });
    }

    function drawLineChart(res) {
        google.charts.load('current', {'packages': ['corechart'], 'language': lang});
        google.charts.setOnLoadCallback(function () {
            let data = google.visualization.arrayToDataTable(res.data);
            let options = res.options;
            let chart = new google.visualization.LineChart(document.getElementById('chart-div'));
            let formatting = new google.visualization.NumberFormat({
                decimalSymbol: decimal_separator,
                groupingSymbol: thousands_separator
            });
            formatting.format(data, 1);
            chart.draw(data, options);
        });
    }

    function drawPieChart(res) {
        google.charts.load('current', {'packages': ['corechart'], 'language': lang});
        google.charts.setOnLoadCallback(function () {
            let data = google.visualization.arrayToDataTable(res.data);
            let options = res.options;
            let chart = new google.visualization.PieChart(document.getElementById('chart-div'));
            let formatting = new google.visualization.NumberFormat({
                decimalSymbol: decimal_separator,
                groupingSymbol: thousands_separator
            });
            formatting.format(data, 1);
            chart.draw(data, options);
        });

    }

    function drawDonutChart(res) {
        google.charts.load("current", {packages: ["corechart"], 'language': lang});
        google.charts.setOnLoadCallback(function () {
            let data = google.visualization.arrayToDataTable(res.data);
            let options = Object.assign({}, res.options, {pieHole: 0.4});
            let chart = new google.visualization.PieChart(document.getElementById('chart-div'));
            let formatting = new google.visualization.NumberFormat({
                decimalSymbol: decimal_separator,
                groupingSymbol: thousands_separator
            });
            formatting.format(data, 1);
            chart.draw(data, options);
        });
    }

    function drawAreaChart(res) {
        google.charts.load('current', {'packages': ['corechart'], 'language': lang});
        google.charts.setOnLoadCallback(function () {
            let data = google.visualization.arrayToDataTable(res.data);
            let options = res.options;
            let chart = new google.visualization.AreaChart(document.getElementById('chart-div'));
            let formatting = new google.visualization.NumberFormat({
                decimalSymbol: decimal_separator,
                groupingSymbol: thousands_separator
            });
            formatting.format(data, 1);
            chart.draw(data, options);
        });
    }

    function drawScatterChart(res) {
        google.charts.load('current', {'packages': ['corechart'], 'language': lang});
        google.charts.setOnLoadCallback(function () {
            let data = google.visualization.arrayToDataTable(res.data);
            let options = res.options;
            let chart = new google.visualization.ScatterChart(document.getElementById('chart-div'));
            let formatting = new google.visualization.NumberFormat({
                decimalSymbol: decimal_separator,
                groupingSymbol: thousands_separator
            });
            formatting.format(data, 1);
            chart.draw(data, options);
        });
    }

    function drawStackedBarChart(res) {
        google.charts.load('current', {packages: ['corechart', 'bar']});
        google.charts.setOnLoadCallback(function () {
            let data = google.visualization.arrayToDataTable(res.data);
            let options = Object.assign({}, res.options, {
                legend: {position: 'top', maxLines: 3},
                bar: {groupWidth: '75%'},
                isStacked: true,
            });
            let chart = new google.visualization.ColumnChart(document.getElementById('chart-div'));
            let formatting = new google.visualization.NumberFormat({
                decimalSymbol: decimal_separator,
                groupingSymbol: thousands_separator
            });
            formatting.format(data, 1);
            chart.draw(data, options);
        });
    }

    if ($('.edit-dashboard').length) {
        let $function_active = $('.functions-dropdown').find('.function.active'),
            $field_active = $('.functions-dropdown').find('.field.active');

        if(!$function_active.length && !$field_active.length && $chart_type.val() === 'Table'){
            drawChart($chart_type.val());
        }else{
            $('.functions-dropdown').find('.function.active').trigger('click');
            $('.functions-dropdown').find('.field.active').trigger('click');
            $('.summarize-dropdown').find('.field.active').trigger('click');
        }
    }

    $('.delete-report').on('click', function (e) {
        let id = $(this).data('id');
        bootbox.confirm("Are you sure want to delete report?", function (result) {
            if (result) {
                $.ajax({
                    type: 'DELETE',
                    url: `/report/${id}`,
                    success: function (res) {
                        if (res) {
                            window.location = '/';
                        }
                    }
                })
            }
        });
    });

    $('.remove-report').on('click', function (e) {
        let id = $(this).data('id'),
            dashboard_id = $(this).data('dashboard-id'),
            $chart = $(this).parents('.chart');

        bootbox.confirm("Are you sure want to remove this chart from dashboard?", function (result) {
            if (result) {
                $.ajax({
                    type: 'DELETE',
                    url: `/dashboard/chart`,
                    data: {
                        id, dashboard_id
                    },
                    success: (res) => {
                        if (res) {
                            $chart.remove();
                        }
                    }
                })
            }
        });
    });

    $(".dashboard-visibility").on('change', function (e) {
        console.log($(this).val() === '1');
        if ($(this).val() === '1') {
            $('.dashboard-user-groups').removeClass('d-none');
        } else {
            $('.dashboard-user-groups').addClass('d-none');
        }
    });

});